<template>
  <div class="dynamic-petition">
    <!-- LOADING -->
    <div class="wwf-loading-container" v-show="isLoading">
      <div class="wwf-loading">
        <span></span>
      </div>
    </div>

    <!-- PETITION -->
    <header class="header-container">
      <DynamicHeader :content="headerContent"></DynamicHeader>
    </header>

    <main>
      <div class="petition-container">
        <section class="form-section">
          <div class="form-wrapper" v-if="!isLoading">
            <PetitionBio
              :datalayerName="datalayerName"
              :programName="programName"
              :counterLimit="counterLimit"
              :counterTitle="counterTitle"
              :signButtonValue="signButtonValue"
              :viewMessageButtonValue="viewMessageButtonValue"
              :viewMessagePosition="viewMessagePosition"
              :letterTitle="letterTitle"
              :letterMessage="letterMessage"
              :stepupId="stepupId"
              :sendToIve="sendToIve"
              :iveSupplier="iveSupplier"
              :iveSource="iveSource"
            >
            </PetitionBio>
          </div>
        </section>

        <section class="content-section">
          <DynamicContent :content="mainContent"></DynamicContent>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
import DynamicHeader from "./Header";
import DynamicContent from "./Content";
import PetitionBio from "../forms/PetitionBio";

import { getParameterByName } from "../../helpers";

export default {
  name: "DynamicPetition",
  components: {
    DynamicHeader,
    DynamicContent,
    PetitionBio,
  },

  data() {
    return {
      isLoading: true,

      headerContent: null,
      mainContent: null,

      programName: null,

      counterTitle: null,
      signButtonValue: null,
      viewMessageButtonValue: null,
      viewMessagePosition: null,
      letterMessage: null,
      letterTitle: null,
      stepupId: null,

      sendToIve: false,
      iveSupplier: null,
      iveSource: null,
    };
  },
  props: {
    datalayerName: {
      type: String,
      default: "cop21",
    },
    counterLimit: {
      type: Number,
      default: 10000,
    },
    defaultPetitionId: {
      type: String,
      default: "petition-cop-oceans",
    },
  },
  computed: {},

  async created() {
    const petitionId = getParameterByName("p", window.top.location.href) || this.defaultPetitionId;
    const data = await this.$store.dispatch(
      "getContentMessageById",
      petitionId
    );

    this.headerContent = data.petition;
    this.mainContent = data.content;
    this.programName = data.petition.programName;
    this.counterTitle = data.petition.formDescription;
    this.signButtonValue = data.petition.submitText;
    this.viewMessageButtonValue = data.petition.viewLetterText;
    this.viewMessagePosition = data.petition.viewLetterPosition;
    this.letterTitle = data.petition.letterHeading;
    this.letterMessage = data.petition.letterId;
    this.stepupId = data.petition.stepupId;

    this.sendToIve = !!data.petition.sendToIve;
    this.iveSupplier = data.petition.iveSupplier;
    this.iveSource = data.petition.iveSource;

    this.isLoading = false;

    // this.$store.dispatch("logLandingVisit", this.programName);
  },
};
</script>

<style scoped>
.dynamic-petition {
  position: relative;
}

.header-container {
  width: 100%;
  height: 85vh;
  min-height: 600px;
  background: #222;
  color: #fff;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.petition-container {
  z-index: 2;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  max-width: 1100px;
  margin: 0 auto;
  padding: 50px 0;
}

.form-section {
  order: 2;
  width: 40%;
  padding: 0 25px 0 12px;
}

.form-wrapper {
  margin-top: -350px;
  padding: 20px;
  background: white;
  box-shadow: 0px 4px 114px rgba(0, 0, 0, 0.18);
}

.content-section {
  order: 1;
  width: 60%;
  padding: 0 12px 0 25px;
}

/* Overrides */
.form-wrapper >>> .flip-wrapper {
  padding: 0;
  background-color: transparent;
}

@media only screen and (max-width: 64em) {
  .form-section,
  .content-section {
    width: 50%;
  }
}

@media only screen and (max-width: 40em) {
  .header-container {
    justify-content: center;
    align-items: flex-start;
  }

  .form-section {
    order: 1;
    width: 100%;
    padding: 0 25px 25px;
  }

  .content-section {
    order: 2;
    width: 100%;
    padding: 0 25px;
  }

  .petition-container {
    padding: 210px 0px;
  }
}
</style>


// WEBPACK FOOTER //
// DynamicPetition.vue?05dba799